var TRANSLATED_TYPE_CODES = new Set([
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
]);
var MARC_VARIANT_TYPES = new Set([
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
]);
export var formatVariantName = function (variant) {
    return variant.subtitle ? "".concat(variant.name, " : ").concat(variant.subtitle) : variant.name;
};
// MARC 246 ind. 2 first: most of its types have no faithful ONIX equivalent; ONIX 00 means no type.
var variantTypeLabelId = function (variant) {
    if (variant.marcType && MARC_VARIANT_TYPES.has(variant.marcType)) {
        return "ui-br-legaldeposits.titles.variantTitles.marcType.".concat(variant.marcType);
    }
    if (variant.typeCode && TRANSLATED_TYPE_CODES.has(variant.typeCode)) {
        return "ui-br-legaldeposits.titles.variantTitles.type.".concat(variant.typeCode);
    }
    if (variant.typeCode && variant.typeCode !== "00" && variant.typeLabel) {
        return null;
    }
    return "ui-br-legaldeposits.titles.variantTitles.type.none";
};
export var variantTypeLabel = function (variant, formatMessage) {
    var _a;
    var id = variantTypeLabelId(variant);
    return id ? formatMessage({ id: id }) : ((_a = variant.typeLabel) !== null && _a !== void 0 ? _a : "");
};
export var describeVariant = function (variant, formatMessage) {
    return "".concat(formatVariantName(variant), " (").concat(variantTypeLabel(variant, formatMessage), ")");
};
export var variantSummary = function (variants) {
    return variants.length === 0
        ? null
        : { first: formatVariantName(variants[0]), more: variants.length - 1 };
};
